'use client'

import * as React from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { Slider as SliderPrimitive } from 'radix-ui'

function Slider({
	className,
	defaultValue,
	value,
	min = 0,
	max = 100,
	...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
	const _values = React.useMemo(
		() =>
			Array.isArray(value)
				? value
				: Array.isArray(defaultValue)
					? defaultValue
					: [min, max],
		[value, defaultValue, min, max],
	)

	return (
		<SliderPrimitive.Root
			data-slot='slider'
			defaultValue={defaultValue}
			value={value}
			min={min}
			max={max}
			className={cn(
				'relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-vertical:h-full data-vertical:min-h-40 data-vertical:w-auto data-vertical:flex-col',
				className,
			)}
			{...props}
		>
			<SliderPrimitive.Track
				data-slot='slider-track'
				className='relative h-2 grow overflow-hidden rounded-full bg-slate-100 data-horizontal:h-1 data-horizontal:w-full data-vertical:h-full data-vertical:w-1'
			>
				<SliderPrimitive.Range
					data-slot='slider-range'
					className='bg-primary absolute select-none data-horizontal:h-full data-vertical:w-full'
				/>
			</SliderPrimitive.Track>

			{Array.from({ length: _values.length }, (_, index) => (
				<SliderPrimitive.Thumb
					key={index}
					data-slot='slider-thumb'
					className='bg-primary ring-ring/50 relative block size-3 shrink-0 rounded-full transition-[color,box-shadow] select-none after:absolute after:-inset-2 hover:ring-3 focus-visible:ring-3 focus-visible:outline-hidden active:ring-3 disabled:pointer-events-none disabled:opacity-50'
				/>
			))}
		</SliderPrimitive.Root>
	)
}

export { Slider }
